<div class="card">
  @if (iframeUrl) {
    <div>
      <iframe
        [src]="iframeUrl | safeUrl"
        style="width: 100%; min-height: 500px !important; height: 75vh;"
      ></iframe>
    </div>
  }

  @if (downloadableDocument) {
    <div class="d-flex flex-column justify-content-center align-items-center text-muted w-100 py-5">
      <i class="far fa-file" style="font-size: 3rem;"></i>
      <p class="mt-2 mb-0">Preview not available for this file type</p>
      <button type="button" class="btn btn-primary mt-3" (click)="downloadDocument()">
        <i class="fas fa-download me-1"></i> Download {{downloadableDocument.fileName}}
      </button>
    </div>
  }

  @if (errorMessage) {
    <div class="alert alert-danger border-0" role="alert">
      <strong>{{errorMessage}}</strong>
    </div>
  }
</div>